import React, { useEffect, useState } from "react";
import {
    AutocompleteInput,
    CreateButton,
    Datagrid, EditButton, ExportButton, List, TextField, TextInput, TopToolbar, FilterButton, ReferenceInput, DateField, FunctionField
} from "react-admin";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import MainLayout from "../layout/MainLayout";
import PeopleIcon from '@mui/icons-material/People';
import { StatusField } from "./StatusField";
import Color from "../layout/color/Color";
import FontSize from "../layout/FontSize";


const saveButton = {
    bgcolor: Color.Main,
    borderRadius: '30px',
    border: '1px solid',
    fontWeight: '500',
    textAlign: 'center',
    padding: '4px 8px',
    color: Color.Button,
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': { background: Color.Button, color: Color.Normal }
  };
  
  const backButton = {
    bgcolor: Color.Button,
    borderRadius: '30px',
    border: "1px solid #055C2D",
    color: Color.Main,
    fontWeight: '500',
    textAlign: 'center',
    padding: '4px 8px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': { background: Color.Main, color: Color.Button }
  };
const RoleList = [
    {
        id: 1,
        name: 'Master Manager',
    },
    {
        id: 2,
        name: 'Manager'
    },
    {
        id: 3,
        name: 'Cashier'
    }
]

const EmployeeListActionToolbar = ({ children, ...props }) => (
    <Box sx={{ alignItems: 'center', display: 'flex' }}>
        {children}
    </Box>
);

const EmployeeListAction = () => {
    return (
        <TopToolbar>
            <FilterButton  sx={{color: Color.Main}}/>
            <CreateButton label="Create New"  sx={saveButton}/>
            <ExportButton sx={backButton} />
        </TopToolbar>
    )
}

const employeeFilters = [
    <TextInput source="fullname" label="Search name" alwaysOn={true} />,
    <AutocompleteInput
        optionText='name' source="role" choices={RoleList}
    />,
    <ReferenceInput source="submerchantID" reference="SubMerchant" alwaysOn={true}>
        <AutocompleteInput
            optionText='name'
            size="small"
            fullWidth
            label="Select SubMerchant"
            sx={{ width: '220px' }}
        />
    </ReferenceInput>
];

function getWindowDimensions() {
    const { innerWidth: width } = window;
    return {
        width
    };
}

export const EmployeeList = (props) => {

    const [currentScreen, setCurrentScreen] = useState(getWindowDimensions());
    const [currentScreenPx, setCurrentScreenPx] = useState('');

    useEffect(() => {
        function handleResize() {
            setCurrentScreen(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setCurrentScreenPx((currentScreen.width - 70) + 'px')
    }, [currentScreen])

    return (
        <MainLayout>
            <Grid sx={{ textAlign: 'left' }}>
                <Button endIcon={<PeopleIcon  sx={{ color: Color.Main}}/>} sx={{ textAlign: 'left', ml: 1, cursor: 'default' }} size="medium">
                    <Typography variant="h3">
                        Employee Management
                    </Typography>
                </Button>
            </Grid>
            <Divider sx={{ width: '100%', mb: 2 }} />
            <List
                actions={<EmployeeListAction />}
                filters={employeeFilters}
            >
                <Datagrid
                    bulkActionButtons={false}
                    sx={{
                        '& .RaDatagrid-tableWrapper': {
                            xs: {
                                overflowX: 'scroll',
                                width: currentScreenPx,
                                overflowY: 'hidden',
                                mx: '20px',
                                whiteSpace: 'nowrap'
                            },
                            md: {
                                overflowX: 'scroll',
                                width: currentScreenPx,
                                overflowY: 'hidden',
                                mx: '20px',
                                whiteSpace: 'nowrap'
                            },
                            lg: {
                                overflowX: 'scroll',
                                width: '100%',
                                overflowY: 'hidden',
                                whiteSpace: 'nowrap'
                            },
                            xl: {
                                overflowX: 'scroll',
                                width: '100%',
                                overflowY: 'hidden',
                                whiteSpace: 'nowrap'
                            }
                        }
                    }}
                >
                    <TextField source="fullname" />
                    <TextField source="phone" />
                    <TextField source="email" />
                    <FunctionField
                        label="Role"
                        render={record => record.role === 1 ? 'Master Manager' : record.role === 2 ? 'Manager' : 'Cashier'}
                    />
                    <TextField source="address" />
                    <DateField source="created_at" />
                    <StatusField source="status" />
                    <EmployeeListActionToolbar>
                        <EditButton />
                    </EmployeeListActionToolbar>
                </Datagrid>
            </List>
        </MainLayout>
    )
}

